// The "Back card" return link: content links carry ?back=<the page they sit on>, and the card reads it. Pure, so
// tests/returnLink.test.js runs it under plain node.
export const BACK_PARAM = "back";
const MAX_BACK = 300;

// A same-site path out of whatever came in (a query value): decoded once, one leading "/", no scheme, no
// backslash, no control characters. Its own query and hash are dropped. null when it is not safe.
export function safeBackPath(value) {
    if (typeof value !== "string" || value === "") return null;
    let v = value;
    try {
        v = decodeURIComponent(v);
    } catch {
        return null;
    }
    if (v.length > MAX_BACK) return null;
    if (!v.startsWith("/") || v.startsWith("//")) return null;
    if (/[\\\u0000-\u001f\u007f]/.test(v)) return null;
    v = v.split(/[?#]/)[0];
    // A second decode must not turn it into something else (%252F%252F...).
    if (/^\/[\/\\]/.test(v) || /%2f|%5c|%0[0-9a-f]/i.test(v)) return null;
    return v === "" ? null : v;
}

const pathOf = (href) => String(href).split(/[?#]/)[0];

// href with back=<currentPath> added, for a same-site content link. Anything else (anchors, tel:, mailto:, http,
// protocol-relative, the page itself, no safe current path) comes back untouched.
export function withBack(href, currentPath) {
    if (typeof href !== "string" || !href.startsWith("/") || href.startsWith("//")) return href;
    const back = safeBackPath(currentPath);
    if (!back) return href;
    if (pathOf(href).replace(/\/+$/, "") === back.replace(/\/+$/, "")) return href;
    const hashAt = href.indexOf("#");
    const hash = hashAt >= 0 ? href.slice(hashAt) : "";
    const rest = hashAt >= 0 ? href.slice(0, hashAt) : href;
    const q = rest.indexOf("?");
    const base = q >= 0 ? rest.slice(0, q) : rest;
    const params = new URLSearchParams(q >= 0 ? rest.slice(q + 1) : "");
    params.set(BACK_PARAM, back);
    return `${base}?${params.toString()}${hash}`;
}

// url (path + query) without the back param: what the server caches, canonicalises and shares by.
export function stripBack(url) {
    const s = String(url ?? "");
    const q = s.indexOf("?");
    if (q < 0) return s;
    const hashAt = s.indexOf("#", q);
    const hash = hashAt >= 0 ? s.slice(hashAt) : "";
    const query = s.slice(q + 1, hashAt >= 0 ? hashAt : undefined);
    const kept = query.split("&").filter((p) => p !== "" && p.split("=")[0] !== BACK_PARAM);
    return s.slice(0, q) + (kept.length ? `?${kept.join("&")}` : "") + hash;
}
